<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card m-5">
          <div class="card-header">
            <h1 class="text-center">Créer un compte</h1>
          </div>
          <div class="card-body">
            <!-- Message d'erreur global -->
            <div 
              v-if="errorMessage" 
              class="alert alert-danger" 
              role="alert"
              aria-live="assertive"
            >
              {{ errorMessage }}
            </div>

            <form @submit.prevent="register" novalidate>
              <!-- Pseudo -->
              <div class="mb-3">
                <label for="pseudo" class="form-label">
                  Pseudo
                  <span class="text-danger" aria-label="requis">*</span>
                </label>
                <input 
                  v-model="pseudo" 
                  type="text" 
                  class="form-control" 
                  :class="{ 'is-invalid': fieldErrors.pseudo }"
                  id="pseudo" 
                  placeholder="Votre pseudo"
                  aria-describedby="pseudoHelp pseudoError"
                  :aria-invalid="!!fieldErrors.pseudo"
                  autocomplete="username"
                  @blur="validatePseudo"
                  required 
                />
                <small id="pseudoHelp" class="form-text text-muted">
                  3 à 20 caractères (lettres, chiffres, tirets et underscores)
                </small>
                <div 
                  v-if="fieldErrors.pseudo" 
                  id="pseudoError"
                  class="invalid-feedback"
                  role="alert"
                >
                  {{ fieldErrors.pseudo }}
                </div>
              </div>

              <!-- Email -->
              <div class="mb-3">
                <label for="email" class="form-label">
                  Courriel
                  <span class="text-danger" aria-label="requis">*</span>
                </label>
                <input 
                  v-model="email" 
                  type="email" 
                  class="form-control" 
                  :class="{ 'is-invalid': fieldErrors.email }"
                  id="email" 
                  placeholder="exemple@email.com"
                  aria-describedby="emailHelp emailError"
                  :aria-invalid="!!fieldErrors.email"
                  autocomplete="email"
                  @blur="validateEmail"
                  required 
                />
                <small id="emailHelp" class="form-text text-muted">
                  Votre adresse email
                </small>
                <div 
                  v-if="fieldErrors.email" 
                  id="emailError"
                  class="invalid-feedback"
                  role="alert"
                >
                  {{ fieldErrors.email }}
                </div>
              </div>

              <!-- Mot de passe -->
              <div class="mb-3">
                <label for="password" class="form-label">
                  Mot de passe
                  <span class="text-danger" aria-label="requis">*</span>
                </label>
                <input 
                  v-model="password" 
                  type="password" 
                  class="form-control" 
                  :class="{ 'is-invalid': fieldErrors.password }"
                  id="password" 
                  placeholder="••••••••"
                  aria-describedby="passwordHelp passwordError"
                  :aria-invalid="!!fieldErrors.password"
                  autocomplete="new-password"
                  @blur="validatePassword"
                  required 
                />
                <small id="passwordHelp" class="form-text text-muted">
                  Au moins 8 caractères, avec majuscule, minuscule et chiffre
                </small>
                <div 
                  v-if="fieldErrors.password" 
                  id="passwordError"
                  class="invalid-feedback"
                  role="alert"
                >
                  {{ fieldErrors.password }}
                </div>
              </div>

              <!-- Confirmation mot de passe -->
              <div class="mb-3">
                <label for="confirmPassword" class="form-label">
                  Confirmer le mot de passe
                  <span class="text-danger" aria-label="requis">*</span>
                </label>
                <input 
                  v-model="confirmPassword" 
                  type="password" 
                  class="form-control" 
                  :class="{ 'is-invalid': fieldErrors.confirmPassword }"
                  id="confirmPassword" 
                  placeholder="••••••••"
                  aria-describedby="confirmPasswordError"
                  :aria-invalid="!!fieldErrors.confirmPassword"
                  autocomplete="new-password"
                  @blur="validateConfirmPassword"
                  required 
                />
                <div 
                  v-if="fieldErrors.confirmPassword" 
                  id="confirmPasswordError"
                  class="invalid-feedback"
                  role="alert"
                >
                  {{ fieldErrors.confirmPassword }}
                </div>
              </div>

              <!-- Acceptation des conditions -->
              <!-- <div class="mb-3 form-check">
                <input 
                  v-model="acceptTerms" 
                  type="checkbox" 
                  class="form-check-input" 
                  :class="{ 'is-invalid': fieldErrors.acceptTerms }"
                  id="acceptTerms"
                  aria-describedby="termsError"
                  @change="validateAcceptTerms"
                  required
                />
                <label class="form-check-label" for="acceptTerms">
                  J'accepte les <a href="/terms" target="_blank">conditions d'utilisation</a>
                  <span class="text-danger" aria-label="requis">*</span>
                </label>
                <div 
                  v-if="fieldErrors.acceptTerms" 
                  id="termsError"
                  class="invalid-feedback d-block"
                  role="alert"
                >
                  {{ fieldErrors.acceptTerms }}
                </div>
              </div> -->

              <!-- Bouton de soumission -->
              <div class="d-grid gap-2">
                <button 
                  type="submit" 
                  class="btn btn-primary" 
                  :disabled="isLoading"
                  :aria-busy="isLoading"
                >
                  <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Création du compte...</span>
                  </span>
                  <span v-else>Créer mon compte</span>
                </button>
              </div>

              <!-- Lien vers la connexion -->
              <hr class="my-4">
              
              <div class="text-center">
                <p class="text-muted">Vous avez déjà un compte ?</p>
                <router-link to="/login" class="btn btn-outline-secondary">
                  Se connecter
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '../services/authService';

export default {
  name: 'RegisterForm',
  
  data() {
    return {
      pseudo: '',
      email: '',
      password: '',
      confirmPassword: '',
      // acceptTerms: false,
      isLoading: false,
      errorMessage: '',
      fieldErrors: {
        pseudo: '',
        email: '',
        password: '',
        confirmPassword: ''
        // acceptTerms: ''
      }
    };
  },
  
  methods: {
    /**
     * Valide le pseudo
     */
    validatePseudo() {
      const pseudoRegex = /^[a-zA-Z0-9_-]{3,20}$/;
      
      if (!this.pseudo) {
        this.fieldErrors.pseudo = 'Le pseudo est requis.';
        return false;
      }
      
      if (this.pseudo.length < 3) {
        this.fieldErrors.pseudo = 'Le pseudo doit contenir au moins 3 caractères.';
        return false;
      }
      
      if (this.pseudo.length > 20) {
        this.fieldErrors.pseudo = 'Le pseudo ne peut pas dépasser 20 caractères.';
        return false;
      }
      
      if (!pseudoRegex.test(this.pseudo)) {
        this.fieldErrors.pseudo = 'Le pseudo ne peut contenir que des lettres, chiffres, tirets et underscores.';
        return false;
      }
      
      this.fieldErrors.pseudo = '';
      return true;
    },
    
    /**
     * Valide l'email
     */
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
      if (!this.email) {
        this.fieldErrors.email = 'L\'email est requis.';
        return false;
      }
      
      if (!emailRegex.test(this.email)) {
        this.fieldErrors.email = 'Format d\'email invalide.';
        return false;
      }
      
      this.fieldErrors.email = '';
      return true;
    },
    
    /**
     * Valide le mot de passe
     */
    validatePassword() {
      if (!this.password) {
        this.fieldErrors.password = 'Le mot de passe est requis.';
        return false;
      }
      
      if (this.password.length < 8) {
        this.fieldErrors.password = 'Le mot de passe doit contenir au moins 8 caractères.';
        return false;
      }
      
      // Au moins une majuscule
      if (!/[A-Z]/.test(this.password)) {
        this.fieldErrors.password = 'Le mot de passe doit contenir au moins une majuscule.';
        return false;
      }
      
      // Au moins une minuscule
      if (!/[a-z]/.test(this.password)) {
        this.fieldErrors.password = 'Le mot de passe doit contenir au moins une minuscule.';
        return false;
      }
      
      // Au moins un chiffre
      if (!/[0-9]/.test(this.password)) {
        this.fieldErrors.password = 'Le mot de passe doit contenir au moins un chiffre.';
        return false;
      }
      
      this.fieldErrors.password = '';
      return true;
    },
    
    /**
     * Valide la confirmation du mot de passe
     */
    validateConfirmPassword() {
      if (!this.confirmPassword) {
        this.fieldErrors.confirmPassword = 'Veuillez confirmer votre mot de passe.';
        return false;
      }
      
      if (this.password !== this.confirmPassword) {
        this.fieldErrors.confirmPassword = 'Les mots de passe ne correspondent pas.';
        return false;
      }
      
      this.fieldErrors.confirmPassword = '';
      return true;
    },
    
    /**
     * Valide l'acceptation des conditions
     */
    // validateAcceptTerms() {
    //   if (!this.acceptTerms) {
    //     this.fieldErrors.acceptTerms = 'Vous devez accepter les conditions d\'utilisation.';
    //     return false;
    //   }
      
    //   this.fieldErrors.acceptTerms = '';
    //   return true;
    // },
    
    /**
     * Valide tous les champs
     */
    validateAll() {
      const isPseudoValid = this.validatePseudo();
      const isEmailValid = this.validateEmail();
      const isPasswordValid = this.validatePassword();
      const isConfirmPasswordValid = this.validateConfirmPassword();
      // const isAcceptTermsValid = this.validateAcceptTerms();
      
      return isPseudoValid && 
             isEmailValid && 
             isPasswordValid && 
             isConfirmPasswordValid 
            //  && 
            //  isAcceptTermsValid;
    },
    
    /**
     * Retourne un message d'erreur approprié selon le code d'erreur
     */
    getErrorMessage(error) {
      if (error.response) {
        const status = error.response.status;
        const data = error.response.data;
        
        switch (status) {
          case 400:
            // Erreur de validation côté serveur
            if (data.message) {
              return data.message;
            }
            return 'Les données fournies sont invalides.';
            
          case 409:
            // Conflit (email ou pseudo déjà utilisé)
            if (data.field === 'email') {
              return 'Cet email est déjà utilisé.';
            }
            if (data.field === 'pseudo') {
              return 'Ce pseudo est déjà pris.';
            }
            return 'Ce compte existe déjà.';
            
          case 429:
            return 'Trop de tentatives. Réessayez plus tard.';
            
          case 500:
            return 'Erreur serveur. Veuillez réessayer plus tard.';
            
          default:
            return 'Une erreur est survenue lors de la création du compte.';
        }
      }
      
      // Erreur réseau
      if (!navigator.onLine) {
        return 'Pas de connexion internet.';
      }
      
      return 'Une erreur est survenue. Veuillez réessayer.';
    },
    
    /**
     * Soumet le formulaire d'inscription
     */
    async register() {
      // Réinitialise le message d'erreur global
      this.errorMessage = '';
      
      // Valide tous les champs
      if (!this.validateAll()) {
        this.errorMessage = 'Veuillez corriger les erreurs dans le formulaire.';
        return;
      }
      
      this.isLoading = true;
      
      try {
        // Appel à l'API d'inscription
        await authService.register({
          pseudo: this.pseudo,
          email: this.email,
          password: this.password
        });
        
        // Redirection vers la page de connexion après succès
        this.$router.push({
          name: 'Login',
          query: { 
            registered: 'true',
            message: 'Compte créé avec succès ! Vous pouvez maintenant vous connecter.'
          }
        });
        
      } catch (error) {
        this.errorMessage = this.getErrorMessage(error);
        console.error('Registration failed:', error);
        
        // Si l'erreur concerne un champ spécifique, on l'affiche
        if (error.response?.data?.field) {
          const field = error.response.data.field;
          if (this.fieldErrors[field] !== undefined) {
            this.fieldErrors[field] = error.response.data.message || 'Valeur invalide';
          }
        }
        
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
/* Style personnalisé pour les messages d'aide */
.form-text {
  font-size: 0.875rem;
}

/* Animation douce pour les messages d'erreur */
.alert, .invalid-feedback {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Style pour les liens */
a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* Amélioration visuelle du checkbox */
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

/* Responsive */
@media (max-width: 768px) {
  .card {
    margin: 1rem !important;
  }
}
</style>